import $ from 'jquery';
import triggerChatFlow from '../../utils/triggerChatFlow';
import { trackEvent } from '../trackEvent';

export const initEventListenersForTracking = () => {
  $('body').on('click', '.open_chat_button', () => {
    triggerChatFlow();
  });

  $('body').on(
    'click',
    '[data-tracking-annuncifunebri-create-cordogli-start-chat="true"]',
    () => {
      trackEvent('Upselling', {
        type: 'click',
        source: 'main menu',
        success: true,
        offer: 'obituaries',
        purpose: 'upselling',
        intent: 'cordogli',
      });
    }
  );
  $('body').on('click', '[data-tracking-eterno-open-service-not-now]', () => {
    trackEvent('Upselling', {
      success: false,
      offer: 'eterno',
      type: 'click',
      source: 'toolbar',
      purpose: 'upselling',
      intent: 'open_service',
    });
  });
  $('body').on('click', '[data-tracking-eterno-open-service-read-more]', () => {
    trackEvent('Upselling', {
      success: true,
      offer: 'eterno',
      type: 'click',
      source: 'toolbar',
      purpose: 'upselling',
      intent: 'open_service',
    });
  });
};
